<!--
@author: 赵静静
@time: 2021/11/1
@desc: 流标状态
-->
<template>
<div class="projectInvalid">
  <div class="projectName">{{ project.name }}</div>
  <el-tabs type="border-card" v-model="active">
    <el-tab-pane v-for="(item, index) in projectTitleList" :key="index" :label="item.title" :name="item.name">
      <div class="evaluate-div" v-if="item.name === '1'">
        <div class="basic evaluate-content">
          <div class="evaluate-title">{{ reason }}</div>
          <div class="timeBox">
            <div class="time">
              <span class="timeTitle">投标金额</span>
              <span>-</span>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="project-info">
          <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
          <projectInfo :project="project"  :projectId="$route.query.id" :isMyRelease="1" :oldInfo="0"/>
          <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
          <projectInfo :project="project.oldInfo"  :projectId="$route.query.id" :isMyRelease="1" :oldInfo="1"/>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { getNormalProjectInfo, failReason } from '@api/project'
import projectInfo from '@views/components/projectInfo'
export default {
  name: 'projectInvalid',
  components: { projectInfo },
  data () {
    return {
      active: '1',
      projectTitleList: [
        { name: '1', title: '投标人' },
        { name: '2', title: '项目详情' }
      ],
      project: {},
      reason: ''
    }
  },
  created () {
    this.id = this.$route.query.id
    this.failReason()
    this.getNormalProjectInfo()
  },
  methods: {
    // 获取项目流标原因
    failReason () {
      failReason({ id: this.id }).then(res => {
        if (res.data.code === 200) {
          this.reason = res.data.data.reason
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取项目详情
    getNormalProjectInfo () {
      getNormalProjectInfo({ id: this.id }).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.projectInvalid{
  width: 75%;
  .evaluate-div {
   padding: 24px 0;
    color: #333333;
  }
  .evaluate-title {
   font-size: 20px;
    margin-bottom: 16px;
  }
  .timeTitle{
    color: #999999;
    font-size: 18px;
    margin-right: 10px;
  }
}
</style>
